/** Widget glassmorphism d'un actif — déployé au clic sur un point du calque. */
import { X, ShieldCheck } from 'lucide-react';
import { eur } from './deviceVault';

export const AssetWidget = ({ asset, color, onClose }) => (
  <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-[690] w-[340px] rounded-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-3 duration-200"
       style={{ background: 'rgba(18,19,26,0.55)', backdropFilter: 'blur(20px)', border: `1px solid ${color}55`, boxShadow: '0 22px 60px rgba(0,0,0,0.55)' }}
       data-testid="asset-widget">
    <div className="h-1 w-full" style={{ background: `linear-gradient(90deg, ${color}, transparent)` }} />
    <div className="p-4">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h3 className="text-[14px] font-bold text-white leading-tight">{asset.name}</h3>
          <p className="text-[10.5px] text-gray-400 mt-0.5">{asset.region}</p>
        </div>
        <button type="button" onClick={onClose} data-testid="asset-widget-close">
          <X className="w-4 h-4 text-gray-400 hover:text-white" />
        </button>
      </div>
      <div className="mt-3 flex items-end justify-between">
        <span className="text-[22px] font-black tabular-nums" style={{ color }}>{eur(asset.value)}</span>
        <span className="text-[11px] font-bold px-2 py-0.5 rounded-full tabular-nums"
              style={{
                background: asset.perf >= 0 ? 'rgba(52,211,153,0.15)' : 'rgba(244,63,94,0.15)',
                color: asset.perf >= 0 ? '#6EE7B7' : '#FDA4AF',
              }}>
          {asset.perf >= 0 ? '+' : ''}{asset.perf}%
        </span>
      </div>
      <p className="mt-2 text-[11.5px] text-gray-300 leading-snug">{asset.detail}</p>
      <div className="mt-3 flex items-center gap-1.5 text-[9.5px] text-gray-500">
        <ShieldCheck className="w-3 h-3 text-emerald-400" />
        Valeur déchiffrée localement — jamais transmise à l'API cartographique
      </div>
    </div>
  </div>
);
